module.exports = __webpack_public_path__ + "img/title-l.13f116fe.png";